__turbopack_context__.v({
  "heading": "PaymentLogoSection-module__X8sd7G__heading",
  "logoRow": "PaymentLogoSection-module__X8sd7G__logoRow",
  "paymentLogoSection": "PaymentLogoSection-module__X8sd7G__paymentLogoSection",
});
